import axios from "axios"

const BASE = import.meta.env.VITE_FLAGFORGE_URL
const KEY = import.meta.env.VITE_FLAGFORGE_KEY

export default class FeatureFlags {
  // Valuta tutti i feature flag dell'environment per lo userId dato.
  // La valutazione (targeting/rollout) avviene server-side su FlagForge.
  // Ritorna la mappa { "<flag-key>": bool }. In caso di config mancante o
  // errore di rete ritorna {} (fail-safe: ogni feature resta spenta).
  static async evaluateAll(userId) {
    if (!BASE || !KEY) return {}
    try {
      const { data } = await axios.post(
        `${BASE}/api/evaluate/all`,
        { userId: String(userId) },
        { headers: { Authorization: `Bearer ${KEY}` }, timeout: 3000 }
      )
      return data || {}
    } catch (e) {
      console.error("FlagForge evaluate/all fallito:", e)
      return {}
    }
  }
}
